import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';

export const fetchLogisticModelsList = () => {
  return apiActionCreator({
    'endpoint': '/logistic/models',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_LOGISTIC_MODELS,
      ActionTypes.FETCHED_LOGISTIC_MODELS,
      [
        ActionTypes.FETCHED_LOGISTIC_MODELS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchModelTasksList = (modelId) => {
  return apiActionCreator({
    'endpoint': `/logistic/models/tasks?modelId=${modelId}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_LOGISTIC_MODEL_TASKS,
      ActionTypes.FETCHED_LOGISTIC_MODEL_TASKS,
      [
        ActionTypes.FETCHED_LOGISTIC_MODEL_TASKS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchTargetModelTasksList = (modelId) => {
  return apiActionCreator({
    'endpoint': `/logistic/models/tasks?modelId=${modelId}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_TARGET_LOGISTIC_MODEL_TASKS,
      ActionTypes.FETCHED_TARGET_LOGISTIC_MODEL_TASKS,
      [
        ActionTypes.FETCHED_TARGET_LOGISTIC_MODEL_TASKS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const updateModel = (data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/logistic/models',
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_LOGISTIC_MODEL,
      [
        (response) => {
          dispatch(fetchLogisticModelsList());
          dispatch(buildSuccessMessage(response, 'Tarea actualizadas con éxito.'));
          return {
            'type': ActionTypes.UPDATED_LOGISTIC_MODEL,
            'payload': data,
          };
        },
      ],
      [
        ActionTypes.UPDATED_LOGISTIC_MODEL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  }));
};

export const updateModelTasks = (modelId, data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': `/logistic/models/tasks?modelId=${modelId}`,
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_LOGISTIC_MODEL_TASKS,
      [
        (response) => {
          if (data.action === 'copy') {
            dispatch(fetchTargetModelTasksList(modelId));
            dispatch(buildSuccessMessage(response,
              `${response.copiedTasks} tareas copiadas.
               ${response.alreadyCopiedTasks} tareas ya se encontraban asignadas o están deshabilitadas.`));
          } else {
            dispatch(fetchModelTasksList(modelId));
            const msg = data.action === 'add' ?
              response.copiedTasks === 0 ? 'La tarea ya se encuentra asignada.' : 'Tarea añadida.' :
              'Tareas actualizadas con éxito.';
            dispatch(buildSuccessMessage(response, msg));
          }
          return {
            'type': ActionTypes.UPDATED_LOGISTIC_MODEL_TASKS,
            'payload': data,
          };
        },
      ],
      [
        ActionTypes.UPDATED_LOGISTIC_MODEL_TASKS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  }));
};

export const cleanTargetModelsTasks = () => ({
  'type': ActionTypes.CLEAN_TARGET_LOGISTIC_MODEL_TASKS,
});
